import { getTvObject } from '@costar-ui/cosmos';

var fontOptions = getTvObject({
  color: {
    "default": 'text',
    'neutral-bold': 'text-neutral-bold',
    'neutral-strong': 'text-neutral-strong',
    'neutral-contrast': 'text-neutral-contrast',
    base: 'text-base',
    'status-info': 'text-status-info',
    'status-caution': 'text-status-caution',
    'status-negative': 'text-status-negative',
    'status-positive': 'text-status-positive',
    'accent-highlight': 'text-accent-highlight',
    'accent-emphasize': 'text-accent-emphasize',
    'on-primary': 'text-on-primary',
    'on-primary-subtlest': 'text-on-primary-subtlest',
    'on-primary-moderate': 'text-on-primary-moderate',
    'on-primary-contrast': 'text-on-primary-contrast',
    'on-neutral': 'text-on-neutral',
    'on-status-negative': 'text-on-status-negative',
    'on-status-caution': 'text-on-status-caution',
    'on-status-positive': 'text-on-status-positive'
  },
  size: {
    'p-6': 'text-p-6',
    'p-8': 'text-p-8',
    'p-10': 'text-p-10',
    'p-12': 'text-p-12',
    'p-14': 'text-p-14',
    'p-16': 'text-p-16',
    'p-18': 'text-p-18',
    'p-20': 'text-p-20',
    //'p-22': 'text-p-22'
    'p-24': 'text-p-24',
    'p-28': 'text-p-28',
    'p-32': 'text-p-32',
    'p-36': 'text-p-36',
    'p-42': 'text-p-42',
    //'0.25': 'text-e-0.25', // 0.25em // 4px
    '0.375': 'text-e-0.375',
    // 0.375em // 6px
    '0.5': 'text-e-0.5',
    // 0.5em // 8px
    '0.625': 'text-e-0.625',
    // 0.625em // 10px
    '0.75': 'text-e-0.75',
    // 0.75em // 12px
    '0.875': 'text-e-0.875',
    // 0.875em // 14px
    '1.0': 'text-e-1.0',
    // 1em // 16px
    '1.125': 'text-e-1.125',
    // 1.125em // 18px
    '1.25': 'text-e-1.25',
    // 1.25em // 20px
    //'1.375': 'text-e-1.375'
    '1.5': 'text-e-1.5',
    // 1.5em // 24px
    '1.75': 'text-e-1.75',
    // 1.175em // 28px
    //'1.875': 'text-e-1.875'
    '2.0': 'text-e-2.0',
    // 2em // 32px
    '2.25': 'text-e-2.25',
    // 2.25em // 36px
    //'2.375': 'text-e-2.375'
    '2.625': 'text-e-2.625' // 2.625em // 42px
  },
  // order matter here if we want line height to override the default line height that is normally part of fort-size
  leading: {
    densest: 'leading-densest',
    // 0.5rem // 8px
    denser: 'leading-denser',
    // 0.625rem // 10px
    dense: 'leading-3',
    // 0.75rem // 12px
    snug: 'leading-snug',
    // 0.875rem // 14px
    none: 'leading-4',
    // 1rem // 16px
    compact: 'leading-5',
    // 1.25rem // 20px
    normal: 'leading-6',
    // 1.5rem // 24px
    moderate: 'leading-7',
    // 1.75rem // 28px
    relaxed: 'leading-8',
    // 2rem // 32px
    loose: 'leading-10',
    // 2.5rem // 40px
    loosest: 'leading-loosest' // 3rem // 48px
  },
  tracking: {
    narrower: 'tracking-narrower',
    // -0.0333em / -0.5328px
    narrow: 'tracking-narrow',
    // -0.025em / -0.4px
    normal: 'tracking-normal' // 0em / normal
    // wide: 'tracking-wide',
    // wider: 'tracking-wider',
    // widest: 'tracking-widest'
  },
  weight: {
    //thin: 'font-thin',
    //extraLight: 'font-extralight',
    //light: 'font-light',
    normal: 'font-normal',
    //medium: 'font-medium',
    //semiBold: 'font-semibold',
    bold: 'font-bold'
    //extraBold: 'font-extrabold',
    //black: 'font-black'
  },
  ellipsis: {
    '1': ['block', 'truncate', 'print:text-wrap', 'print:whitespace-normal'],
    '2': ['line-clamp-2', 'print:line-clamp-none'],
    '3': ['line-clamp-3', 'print:line-clamp-none'],
    '4': ['line-clamp-4', 'print:line-clamp-none'],
    '5': ['line-clamp-5', 'print:line-clamp-none'],
    '6': ['line-clamp-6', 'print:line-clamp-none']
  },
  fontFamily: {
    "default": 'font-sans',
    serif: 'font-serif'
  }
});

export { fontOptions as default };
//# sourceMappingURL=font-options.esm.js.map
